



export const jourTransform = (value) => {
    switch (+value) {
        case 1: return 'Lundi';
        case 2: return 'Mardi';
        case 3: return 'Mercredi';
        case 4: return 'Jeudi';
        case 5: return 'Vendredi';
        case 6: return 'Samedi';
        case 7: return 'Dimanche';
    }
};

export const jourOptions = [{
    label: 'Lundi',
    value: 1
}, {
    label: 'Mardi',
    value: 2
}, {
    label: 'Mercredi',
    value: 3
}, {
    label: 'Jeudi',
    value: 4
}, {
    label: 'Vendredi',
    value: 5
}, {
    label: 'Samedi',
    value: 6
}, {
    label: 'Dimanche',
    value: 7
}]



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/resource/select-options-static.ts